const orderedFields = [
  'aboutNameTitle',
  'aboutNameFirst',
  'aboutNameLast',
  'aboutDoB',
  'aboutContactNumber',
  'aboutEmail',
  'aboutAddressRecent',
  'aboutAddressPreviousOwner',
  'aboutPreviousAddress.postcode',
  'yaPassword',
  'yaAdditionalAccount',
  'yaAdditionalAccountNameTitle',
  'yaAdditionalAccountNameFirst',
  'yaAdditionalAccountNameLast',
  'yaAdditionalAccountDoB',
  'yaAdditionalAccountContactNumber',
  'yaAdditionalAccountEmail',
  'yaSecondCbcAccount',
  'yaSecondCbcUseDetails',
  'yaSecondCbcNameTitle',
  'yaSecondCbcNameFirst',
  'yaSecondCbcNameLast',
  'yaSecondCbcDoB',
  'yaSecondCbcContactNumber',
  'yaSecondCbcEmail',
  'ddName',
  'ddSortCode',
  'ddAccountNumber',
  'ddBillingSame',
  'ddBillingAddress',
  'ddBillingAddressForm.postcode',
  'otsFindStatus',
  'broadbandEmergMonitDevice',
  'broadbandEmergAlt',
  'introducedBy',
  'customerReferral',
  'connectorReferral',
  'partnerReferral',
  'rlAcceptMarketing',
  'rlTermsAccept',
];

export { orderedFields };
